export default __webpack_public_path__ + "52f0f69009ab3c161346cd900eecd186.svg";